<template lang="pug">
.document.i_mt_10.i_mt_sm_2
  .main_title.d-flex.align-items-center.i_pb_2
    img(:src="document.FileCategoryIcon")
    h4.i_ml_2 {{ document.FileCategoryName }}
    svg-icon.d-md-none(
      iconClass="arrow_bottom_g",
      className="arrow_bottom_g",
      :class="{ expand: isExpand }"
    )
    .main_title_btn(@click="expand")
    .main_title_cover
  ul.items(v-for="item in document.FileList", :class="{ expand: isExpand }")
    li.item.d-flex.i_mt_3(
      style="cursor: pointer",
      @click="openDocument(item.FileURL)"
    )
      svg-icon(iconClass="ic_download", className="icon")
      p.i_ml_2 {{ item.FileName }}
</template>

<script>
export default {
  name: "Document",
  props: {
    document: Object,
  },
  data() {
    return {
      isExpand: false,
    };
  },
  methods: {
    expand() {
      this.isExpand = !this.isExpand;
    },
    openDocument(url) {
      window.open(url);
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/style/customer_service/document";
</style>
